import { Box, BoxProps } from '@mui/material';
import TrendyolLogo from '../../assets/trendyol.jpeg';
import HepsiburadaLogo from '../../assets/hepsiburada.svg';
import BoynerLogo from '../../assets/boyner.svg';
import N11Logo from '../../assets/n11.png';
import PazaramaLogo from '../../assets/pazarama.png';
import WebLogo from '../../assets/web.png';
import { PartnerPlatform } from '../../interfaces/PartnerPlatform/PartnerPlatform';

function mapPlatformToLogo(platform: PartnerPlatform) {
  switch (platform) {
    case 'trendyol':
      return TrendyolLogo;
    case 'hepsiburada':
      return HepsiburadaLogo;
    case 'boyner':
      return BoynerLogo;
    case 'n11':
      return N11Logo;
    case 'pazarama':
      return PazaramaLogo;
    default:
      return WebLogo;
  }
}

type PartnerPlatformLogoProps = BoxProps & {
  platform: PartnerPlatform;
};

export const PartnerPlatformLogo = ({
  platform,
  ...props
}: PartnerPlatformLogoProps) => {
  return (
    <Box
      component='img'
      src={mapPlatformToLogo(platform)}
      alt={platform}
      width={24}
      height={24}
      {...props}
    />
  );
};
